import { useGlobalModal } from '@/hooks/useGlobalModal';
import { useSuspenseQuery } from '@apollo/client';
import GlobalModal from '@components/GlobalModal';
import { Access } from '@features/authorization';
import { Trans } from '@lingui/macro';
import { type FC } from 'react';
import { GET_DEVICE_ALERTS_RAW_DATA } from './getRawData';
import { Box, Typography } from '@mui/material';

const SuspenseRawDataVisualization: FC<{ deviceId: string }> = ({ deviceId }) => {
  const { data } = useSuspenseQuery(GET_DEVICE_ALERTS_RAW_DATA, {
    variables: {
      deviceId,
    },
  });

  const { rawData } = data.device.alerts;

  return (
    <Box
      maxHeight="60dvh"
      overflow="auto"
      bgcolor={(theme) => theme.palette.background.default}
      p={1}
      borderRadius={2}
    >
      {rawData ? (
        <Typography fontSize="small" component="pre" lineHeight={1.2} fontFamily="mono">
          {JSON.stringify(rawData, null, 2)}
        </Typography>
      ) : (
        <Typography color="text.secondary" fontStyle="italic" pl={1}>
          <Trans>No existen configuraciones para este dispositivo</Trans>
        </Typography>
      )}
    </Box>
  );
};

export const RawDataModal: FC = () => {
  const { globalModalProps, state, onClose } = useGlobalModal('deviceAlertsRawConfiguration');

  return (
    <GlobalModal
      {...globalModalProps}
      authorization={{
        access: Access.DisableDeviceAlertsConfiguration,
        deviceId: state.open ? state.deviceId : undefined,
        onClose,
      }}
      dialogProps={{
        maxWidth: 'sm',
        fullWidth: true,
      }}
      modalTitleProps={{
        title: <Trans>Datos de alertas leídas desde el pipeline</Trans>,
        onClose,
      }}
      modalContentProps={{
        topDivider: true,
      }}
    >
      {state.open && <SuspenseRawDataVisualization deviceId={state.deviceId} />}
    </GlobalModal>
  );
};
